import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

//môi trường
const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_PLANNING_DEPARTMENT_EXPORT_WAREHOUSE");
//$filter=fields/eCreateBy eq '${email.toLowerCase()}'
//eCreateBy

const allFields =
  "Title, eDescription, eReason, eContent, eDepartment,eApprovalComment, eITLeadComment, eITHeadComment, eUnit, eTypeExportWarehouse, eRequests, ePhoneNumber, eRequestStatus, eApprovedBy, eApprovedStatus, eApprovedDate, eApprovedByITLead, eApprovedByITLeadStatus, eApprovedByITLeadDate, eApprovedByITHead, eApprovedByITHeadStatus, eApprovedByITHeadDate, eComments, eInspectionUnitComment, eInspectionUnit, eFileContent";
//PlanningDepartment
export class PlanningDepartmentExportService {
  static async addNewRequest(request: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), request)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMyRequests({ email }: { email: String }) {
    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items?expand=fields(select=${allFields})&$top=1000`
        )
      )
      .then((res) => {
        return res?.data.value.filter((request: any) =>
          request.createdBy.user.email
            .toLowerCase()
            .split("@")[0]
            .includes(email.toLowerCase().split("@")[0])
        ).reverse();
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMyApproval({ email }: { email: String }) {
    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items?expand=fields(select=${allFields})&$top=1000&$filter= 
          fields/eApprovedBy eq '${email.toLowerCase()}'
          or fields/eApprovedByITLead eq '${email.toLowerCase()}'`
        )
      )
      .then((res) => {
        return res.data.value.reverse();
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getDetail(id: string | number) {
    return api
      .get(
        getURL(
          `/sites/${SPSiteId}/lists/${SPListId}/items/${id}?expand=fields(select=${allFields})`
        )
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateRequest(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
}
